export default __webpack_public_path__ + "static/media/icons8-oracle-logo.66d5da8e.svg";